require('./bootstrap');

// Font Awesome
// require('@fortawesome/fontawesome-free/js/all.js');

/**
 * Admin LTE
 */
// Bootstrap 4
require('admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js');
// overlayScrollbars
// require('admin-lte/plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js');
// AdminLTE App
require('admin-lte/dist/js/adminlte.min.js');

// toastr
window.toastr = require('toastr');

window.download = require('downloadjs/download.min.js');

// highcharts
window.Highcharts = require('highcharts');
require('highcharts/highcharts-more')(window.Highcharts);
require('highcharts/modules/solid-gauge')(window.Highcharts);
require('highcharts/modules/accessibility')(window.Highcharts);

// DataTables
// require( 'jszip' );
// require( 'pdfmake' );
require( 'datatables.net-dt' )();
// require( 'datatables.net-buttons-dt' )();
// require( 'datatables.net-buttons/js/buttons.html5.js' )();
